<template>
	<button
		:class="['tabs__button', { 'tabs__button--active': active }]"
		type="button"
		@click="select"
	>
		<slot />
	</button>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			required: true
		},
		active: {
			type: Boolean,
			default: false
		}
	},
	
	methods: {
		select() {
			this.$emit('select', this.value);
		}
	}
};
</script>
